export var notification_ru = {
    notifications: 'Уведомления',
    collapse: 'Свернуть',
    expand: 'Развернуть',
    markAsViewed: 'Отметить как прочитанное',
    markAsNotViewed: 'Отметить как непрочитанное',
    noSubject: 'Без темы',
    endMessageWithNotifications: 'Более ранних уведомлений нет',
    endMessageWithoutNotifications: 'Уведомлений пока что нет',
};
